import React, { useState } from 'react';
import { ButtonGroup, IconButton, Box } from '@mui/material';
import { OrderedListOutlined, } from '@ant-design/icons/lib/icons';
import EditIcon from '@mui/icons-material/Edit';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import { colors } from '../../../../../assets/colors';
import { CODES } from '../../../../../utils/responseCodes';
import { simpleAlerts } from '../../../../../utils/alerts';
import { sortDataListSimple, filterData } from '../../../../../utils/function';
import AreaOrgService from '../../../../../services/areaOrg';

const columns = [
  { id: 'CodArea', label: 'Cód.', width: 50, align: 'left', },
  { id: 'Area', label: 'Area', width: 140, align: 'left', },
  { id: 'Jefe', label: 'Jefe', width: 220, align: 'center', },
  { id: 'actions', label: 'Acciones', width: 80, align: 'center', },
];

const BodyAreaOrganigrama = (props) => {
  const { handleOpen, id_usuarioLogin, setOpenModalLoader, getAreaOrganigrama, dataAreaOrg, setInfoAreaOrg, search, setTipoModal, setTitleSpinner } = props;

  const url = "'" + window.location.pathname + "'";

  let resultSearch = filterData(dataAreaOrg, search, ['Area', 'Jefe']);

  // /** inicio ordenamiento de columnas */
  const [sortConfigTable, setSortConfigTable] = useState({ key: null, direction: "ascending", });

  const handleSortTable = (key) => {
    let direction = "ascending";
    if (sortConfigTable && sortConfigTable.key === key && sortConfigTable.direction === "ascending") {
      direction = "descending";
    }
    setSortConfigTable({ key, direction });
  };

  const sortedDataAreasOrg = sortDataListSimple(resultSearch, sortConfigTable);

  // /** fin ordenamiento de columnas */

  const saveAreaOrgDesactivar = async (infoOrg) => {

    infoOrg.usuarioMod = id_usuarioLogin;
    delete infoOrg.CodJefe;
    setOpenModalLoader(true);
    setTitleSpinner('Eliminando Jefe');
    try {
      const result = await AreaOrgService.saveAreaOrg(url, infoOrg);
      console.log("result: ", result);

      if (result.status === CODES.CREATE_201) {
        simpleAlerts(result.data.message, 'success');
        getAreaOrganigrama();
      } else {
        simpleAlerts(result.response.data.message, 'error');
      }
    } catch (err) {
      console.log('Error en saveProfile', err);
    } finally {
      setOpenModalLoader(false);
    }
  }




  return (
    <Box className='page-body-main'>
      <Box className='page-body-table table-responsive-md' sx={{ height: "30rem", maxHeight: "45rem" }}>
        <table className="table table-hover table-striped table-bordered">
          <thead className='sticky-top' style={{ backgroundColor: colors.quaternary.hex, color: '#ffff' }}>
            <tr>
              {columns.map((column) => (
                <th
                  scope="col"
                  key={column.id}
                  style={{
                    textAlign: column.align,
                    width: column.width,
                    maxWidth: column.width,
                    cursor: 'pointer',
                  }}
                  onClick={() => (column.id !== 'actions' && handleSortTable(column.id))}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ marginRight: 'auto' }}>{column.label}</div>
                    {column.id !== 'actions' && <div><OrderedListOutlined style={{ paddingBottom: 2 }} /></div>}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="table-group-divider">
            {sortedDataAreasOrg?.map((area, indexRow) => {
              return (
                <tr key={"row" + indexRow}>
                  {columns.map((column, indexColumn) => {
                    const value = area[column.id];
                    return (
                      <td key={'col' + indexColumn} align={column.align}>
                        {column.id === 'actions' ?
                          <ButtonGroup
                            disableElevation
                            variant="contained"
                            aria-label="Disabled elevation buttons"
                          >
                            <IconButton aria-label="edit" size="small" title='Editar'
                              onClick={() => { setTipoModal(1); setInfoAreaOrg(area); handleOpen() }}
                            >
                              <EditIcon fontSize='small' color={'primary'} />
                            </IconButton>
                            <IconButton aria-label="delete" size="small" title='Eliminar'
                              onClick={() => { saveAreaOrgDesactivar(area); }}
                            >
                              <DeleteSweepIcon fontSize='small' color={'secondary'} />
                            </IconButton>
                          </ButtonGroup> :
                          value}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </Box>
    </Box >
  );
}

export default BodyAreaOrganigrama;